import React, { useEffect } from "react";
import { graphql } from "gatsby";
import { renderContent } from "../../utilities/renderContent";

export default function Copy({ data }) {
  // Loop over all the copy and add id's to each header
  const split_data = data.copy.split("\n");
  const copy = split_data
    .map((line, i) => {
      if (line.startsWith("<h3>")) {
        let trimmed_line = line
          .toString()
          .toLowerCase()
          .trim()
          .replace("<h3>", "")
          .replace("</h3>", "")
          .replace(" - ", "")
          .replace("section ", "")
          .replace(/[0-9]/g, "")
          .replace(/\.\s+/g, "")
          .replace(/\./g, "")
          .replace(/\,/g, "")
          .replace(/\s+/g, "_");
        return `<div id="${trimmed_line}">${line}</div>`;
      }
      if (line !== ",") {
        return line;
      }
    })
    .join("");

  return (
    <section
      className={`Copy Hero hds-container hds-text-color bg-${data.backgroundColor}`}
    >
      <div className="hds-section bg-gray">
        <div
          dangerouslySetInnerHTML={renderContent(copy)}
          className="hds-copy hds-text-color"
        />
      </div>
    </section>
  );
}

export const copyQuery = graphql`
  fragment CopyComponent on DatoCmsCopy {
    internal {
      type
    }
    backgroundColor
    id
    copy
  }
`;
